import React from 'react';

  import Header from '../../Components/Header';

  import Sidebar from '../../Components/Sidebar';
  
  import PageHeader from '../../Components/PageHeader';
  
  import FormEdit from '../../Components/Page/Edit/Category/FormEdit';


const RegionEdit = () => {
  return (
    <div className="flex">
      <Sidebar />
      <div className="content">
        <Header />
        <PageHeader
          title="Atualizar Região"
          RigthActionButtonTitle="Voltar"
          RigthActionButtonRoute={'/regions'}
        />
        <div>
          <FormEdit pageTitle={'/regions'} accessor={'title'} pageItem={'region'} />
        </div>
      </div>
    </div>
  );
}
// ...
export default RegionEdit

  